import { type FC } from 'react';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Label } from '@wf/sw-ui-kit';
import { Mode } from '@wf/components';

import { useLicenseContext } from '../../LicenseModeContext';
import Separator from '../../../../components/Separator';
import { LicenseField } from '../LicenseField';

import { HeaderTabFields } from '../../types/fieldEnums';

import { fieldNameConverter } from '../../helpers/fieldNameConverter';
import { RimmEntityType } from '../../../rimm/data/rimmEntityEnums';
import { fieldConfigsSelector } from '../../store/selectors';

const PlaceOfLoadingsFields: FC = () => {
  const { t } = useTranslation();
  const fieldConfigs = useSelector(fieldConfigsSelector);
  const { setValue } = useFormContext();
  const { mode } = useLicenseContext();
  const { id = '' } = useParams();

  const isCreatingLicenseFromFilex = mode === Mode.create && !!id;

  const placeOfLoadingEnabled = fieldConfigs[fieldNameConverter(HeaderTabFields.placeOfLoadingCode)]?.hidden === false;
  const placeOfUnloadingEnabled =
    fieldConfigs[fieldNameConverter(HeaderTabFields.placeOfUnloadingCode)]?.hidden === false;

  if (!placeOfLoadingEnabled && !placeOfUnloadingEnabled) {
    return null;
  }

  return (
    <>
      <Separator className="grid-full-width" />
      <LicenseField.RimmSelectField
        label={
          <Label
            helpText={t(
              'Name of the port, airport, station or other place where the goods are loaded on the board of the transporting vehicle'
            )}
          >
            {t('Place of Loading')}
          </Label>
        }
        configName={HeaderTabFields.placeOfLoadingCode}
        isApproximateValue={isCreatingLicenseFromFilex}
        placeholder={t('Search Place of Loading')}
        name={HeaderTabFields.placeOfLoadingCode}
        entity={RimmEntityType.port}
        setValue={setValue}
        minSuggest={2}
        withTag
      />
      <LicenseField.RimmSelectField
        label={
          <Label
            helpText={t(
              'Name of the port, airport, station or other place where the goods are unloaded from the transporting vehicle'
            )}
          >
            {t('Place of Unloading')}
          </Label>
        }
        configName={HeaderTabFields.placeOfUnloadingCode}
        isApproximateValue={isCreatingLicenseFromFilex}
        placeholder={t('Search Place of Unloading')}
        name={HeaderTabFields.placeOfUnloadingCode}
        entity={RimmEntityType.port}
        setValue={setValue}
        minSuggest={2}
        withTag
      />
    </>
  );
};

export default PlaceOfLoadingsFields;
